var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4C2.89543 4 2 4.89543 2 6V16C2 16.9321 2.63766 17.7153 3.50056 17.9371C3.53409 16.0331 5.088 14.5 7 14.5C8.933 14.5 10.5 16.067 10.5 18H13.5C13.5 16.067 15.067 14.5 17 14.5C18.912 14.5 20.4659 16.0331 20.4994 17.9371C21.3623 17.7153 22 16.9321 22 16V12.75H15V11.25H21.4L18.6005 7.75061C18.2209 7.27618 17.6463 7 17.0387 7H15V6C15 4.89543 14.1046 4 13 4H4ZM8.50337 6C8.88329 6 9.24909 6.06042 9.59167 6.17216L8.49371 7.26907C8.1605 7.60196 7.65145 7.68449 7.22996 7.47395L6.1307 6.92485C6.75477 6.35066 7.58808 6 8.50337 6ZM5 9.5C5 8.96189 5.12156 8.45214 5.33873 7.99666L6.64243 8.64788C7.5697 9.11107 8.68961 8.92951 9.42268 8.19714L10.7808 6.84034C11.4794 7.43796 11.9398 8.30553 12 9.28126C10.8095 9.28385 8.2427 9.97352 7.04839 12.6848C5.83978 12.1328 5 10.9144 5 9.5ZM8.50337 13C8.45294 13 8.40277 12.9989 8.35286 12.9968C9.2509 11.2068 10.9473 10.665 11.83 10.6005C11.3683 11.9944 10.0534 13 8.50337 13Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C9 19.1046 8.10457 20 7 20C5.89543 20 5 19.1046 5 18C5 16.8954 5.89543 16 7 16C8.10457 16 9 16.8954 9 18Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckGlobal);
export default __webpack_public_path__ + "static/media/truck-global.5a416a1fe1f8abfaecaeab23408fd7ce.svg";
export { ForwardRef as ReactComponent };